/* global login, license, window, ifCl */
import React, { createContext, useContext, useEffect, useState } from "react";
import { GeminiClient } from "./GeminiClient";
import ProfileContext from "common/ProfileContext";
import { parseClusterResponse } from "common/api";
import BqnContext, { usePrimaryBqn } from "common/BqnContext";

const GeminiContext = createContext({
  geminiClient: undefined,
});

export function useGeminiClient() {
  const context = useContext(GeminiContext);
  return context.geminiClient;
}

export const GeminiContextProvider = ({ children }) => {
  const [geminiClient, setGeminiClient] = useState();
  const profile = useContext(ProfileContext);
  const {
    bqnId,
    clusterStatus,
    loginBqnId,
  } = useContext(BqnContext);
  const primaryBqnId = usePrimaryBqn();
  const mode = clusterStatus?.mode;

  useEffect(() => {
    if (
      !profile ||
      bqnId === undefined ||
      loginBqnId === undefined ||
      mode === undefined ||
      (mode === "cluster" && primaryBqnId === undefined)
    ) {
      return;
    }

    initialize();
  }, [profile, bqnId, loginBqnId, mode, primaryBqnId]);

  function parseHardwareId(response, bqnId) {
    const hardwareIdRegex = new RegExp(`${bqnId}\\s+(0x[0-9A-Fa-f]+)`, "m");
    let match = response.match(hardwareIdRegex);
    return match ? match[1] : null;
  }

  function parseVersion(response, bqnId) {
    const version = parseClusterResponse(response, (res) => {
      const value = res.match(/BQN release: (.*)/);
      if (value) return value[1];
      else return "unknown";
    });

    return version[bqnId];
  }

  function parseGeminiUrlResponse(response) {
    const value = response.match(
      /Chatbot URL: (.*?)\r?\nChatbot secret: (.*?)\r?\n/,
    );
    if (!value) {
      return null;
    }

    return {
      url: value[1],
      secret: value[2],
    };
  }

  function initialize() {
    Promise.all([
      ifCl.run("show hardware id"),
      ifCl.run("show service web parameters"),
      ifCl.run("show version"),
    ]).then(
      ([
        hardwareResponse,
        geminiUrlResponse,
        versionResponse,
      ]) => {
        const hardwareId = parseHardwareId(hardwareResponse, primaryBqnId ?? loginBqnId);
        const { url, secret } = parseGeminiUrlResponse(geminiUrlResponse) || {};
        const version = parseVersion(versionResponse, loginBqnId);
        setGeminiClient(
          new GeminiClient(true, hardwareId, url, secret, version),
        );
      },
    );
  }

  return (
    <GeminiContext.Provider
      value={{
        geminiClient,
      }}
    >
      {children}
    </GeminiContext.Provider>
  );
};

export default GeminiContext;
